import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder as NgFormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { IDeliveryMethod } from 'src/interfaces/delivery-method';
import { IProduct } from '../../interfaces/product';
import { ProductDataSource } from '../../services/product-data-source';

@Component({
    selector: 'product-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ProductEdit implements OnInit {
  public form: FormGroup;
  public itemsSold: number;
  public Product: IProduct;
  public showDeliveryPrice: boolean;
  public deliveryMethods: IDeliveryMethod[] = [
    {
      slug: 'collection',
      label: 'Collection',
      features: {
        product: true,
      },
    },
    {
      slug: 'post',
      label: 'Post',
      features: {
        product: true,
        post: true,
      },
    },
  ];
  protected DataSource: ProductDataSource;

  public constructor(
    protected dialog: MatDialog,
    protected FormBuilder: NgFormBuilder,
    protected DialogRef: MatDialogRef<ProductEdit>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    const { DataSource, Product } = data;

    this.DataSource = DataSource;
    this.Product = Product;
  }

  ngOnInit() {
    this.itemsSold = 0;

    this.buildForm();

    this.resetForm();

    this.formatDeliveryOptions();
  }

  buildForm() {
    this.form = this.FormBuilder.group({
      title: [null],
      price: [null],
      deliveryPrice: [null],
      deliveryMethod: [null],
      repeatablePurchase: [false],
      totalTickets: [null, [Validators.required]],
      ticketsPerPartner: [null],
    });
  }

  onSelectDeliveryMethod($event: any) {
    if (typeof this.deliveryMethods === 'undefined') {
      return;
    }
    const { value: selected } = $event;

    const postDeliveryMethods = this.deliveryMethods
      .filter((method) => method.features && method.features.post)
      .map((method) => method.slug);

    this.showDeliveryPrice = postDeliveryMethods.indexOf(selected.slug) !== -1;

    !this.showDeliveryPrice && this.form.patchValue({ deliveryPrice: null });
  }

  public resetForm() {
    this.form.reset({ repeatablePurchase: false });

    if (this.Product) {
      const { deliveryMethod, ...product } = this.Product;

      this.itemsSold = this.Product.ticketsSold;
      this.form.patchValue({ ...product });
    }

    this.formatDeliveryOptions();

    this.form.markAsPristine();
  }

  public onSubmit() {
    this.form.disable();

    const productId = this.Product ? this.Product.id : null,
      ProductData = this.form.getRawValue();

    ProductData.deliveryMethod = ProductData.deliveryMethod.slug;

    this.DataSource.save(productId, ProductData)
      .then(() => this.DialogRef.close(true))
      .catch(() => this.form.enable());
  }

  private formatDeliveryOptions() {
    this.form.get('deliveryMethod').disable();

    const [defaultMethod] = this.deliveryMethods;

    const { deliveryMethod: selected = defaultMethod.slug } =
      this.Product || {};

    const [deliveryMethod = defaultMethod] = this.deliveryMethods.filter(
      (method) => method.slug === selected
    );

    this.form.patchValue({ deliveryMethod });

    this.onSelectDeliveryMethod(this.form.get('deliveryMethod'));

    this.form.get('deliveryMethod').enable();
  }
}
